import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from "react";
import Upload from "../Icons/Upload";
import { ICON_SIZES } from "../Icons/IconSizes";
export function FileUpload({ onPick, label }) {
    const inputRef = useRef(null);
    return (_jsxs(_Fragment, { children: [_jsx("input", { ref: inputRef, type: "file", hidden: true, onChange: (e) => {
                    const file = e.target.files?.[0];
                    if (file)
                        onPick(file);
                }, accept: ".pdf,.txt,.html" }), _jsxs("div", { tabIndex: 0, onClick: () => inputRef.current?.click(), onKeyDown: (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        inputRef.current?.click();
                    }
                }, className: "text-blue-500 hover:text-blue-700 cursor-pointer text-left", children: [_jsx(Upload, { size: ICON_SIZES.small, additionalClasses: ["inline-block", "mr-1", "pb-1"] }), _jsx("span", { children: label })] })] }));
}
